import React from 'react';
import { TableCell, TableHead, TableRow } from '@material-ui/core';
import { Column, columns } from './settingsHelpers';

interface SettingsTableHeaderProps {
  columns?: Column[];
}

const SettingsTableHeader = ({ columns: settingsColumns }: SettingsTableHeaderProps) => (
  <TableHead>
    <TableRow>
      {(settingsColumns ?? columns).map((column) => (
        <TableCell key={column.id} align="center">
          {column.label}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

export default SettingsTableHeader;
